import { FaqAccordionProps } from './FaqAccordion';

export function parseFaqAccordion(
  subsections: Queries.ContentfulSection001[],
): FaqAccordionProps {
  const faqs = subsections?.map((item: any) => {
    const cases = item?.subsections?.map((subsection: any) => ({
      title: subsection?.title,
      description: subsection?.body,
      image: {
        gatsbyImageData: subsection?.images?.[0]?.desktopImage?.gatsbyImageData,
        description: subsection?.images?.[0]?.desktopImageAltText,
      },
    }));

    return {
      question: item.displayName,
      answer: item.body,
      cases: cases,
    };
  });

  return {
    faqs: faqs,
  };
}
